import {ApiJsonResult} from '../../utils/api/apijsonresult';
import {StringUtils} from '../../utils/string.utils';

export class FeedbackMaster {
    id: number;
    scopeProgramId: number;
    scopeLevelMasterId: number;
    scopeProfileMasterId: number;
    scopeActivityMasterId: number;
    scopeLevelGoalMasterId: number;
    question: string;
    answer: string;
    questionHelp: string;
    yesAnswerTip: string;
    noAnswerTip: string;
    developingAnswerTip: string;
    images: string;
    byParent: string;
    byTherapist: string;
    materialsRequired: string;
    createdBy: string;
    createdDate: any;
    updatedBy: string;
    updatedDate: string;

    static populate(jsonObject: any): FeedbackMaster {
        const obj = new FeedbackMaster();
        obj.id = jsonObject.id;
        obj.scopeProgramId = jsonObject.scopeProgramId;
        obj.scopeLevelMasterId = jsonObject.scopeLevelMasterId;
        obj.scopeProfileMasterId = jsonObject.scopeProfileMasterId;
        obj.scopeActivityMasterId = jsonObject.scopeActivityMasterId;
        obj.scopeLevelGoalMasterId = jsonObject.scopeLevelGoalMasterId;
        obj.question = jsonObject.question;
        obj.answer = jsonObject.answer;
        obj.questionHelp = jsonObject.questionHelp;
        obj.yesAnswerTip = jsonObject.yesAnswerTip;
        obj.noAnswerTip = jsonObject.noAnswerTip;
        obj.developingAnswerTip = jsonObject.developingAnswerTip;
        obj.images = jsonObject.images;
        obj.byParent = jsonObject.byParent;
        obj.byTherapist = jsonObject.byTherapist;
        obj.materialsRequired = jsonObject.materialsRequired;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static apimapper(apijsonResult: ApiJsonResult): FeedbackMaster {
        let obj = null;
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            obj = FeedbackMaster.populate(jsonObject);
        }
        return obj;
    }

    static apimapperLst(apijsonResult: ApiJsonResult): FeedbackMaster [] {
        const lst: FeedbackMaster [] = [];
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            for (let i = 0; i < jsonObject.length; i++) {
                lst.push(FeedbackMaster.populate(jsonObject[i]));
            }
            return lst;
        }
    }
}
